
export class Schedule {
    frequency: string;

    startDate: Date;

    recurrence: number; // for days this is "recur every X days", for weeks this is recur every X weeks

    days: number[]; // the process days when weekly
    months: number[]; // the process months when monthly
    daysOfMonth: number[]; // the dates of the month to process on when monthly
    timezoneOffset: number; // the number of minutes that the local time is offset from UTC

    static getDays(): { num: number, day: string }[] {
        return [
            { num: 1, day: 'Monday' },
            { num: 2, day: 'Tuesday' },
            { num: 3, day: 'Wednesday' },
            { num: 4, day: 'Thursday' },
            { num: 5, day: 'Friday' },
            { num: 6, day: 'Saturday' },
            { num: 7, day: 'Sunday' }
        ];
    }

    static getMonths(): { num: number, month: string }[] {
        return [
            { num: 1, month: 'January' },
            { num: 2, month: 'February' },
            { num: 3, month: 'March' },
            { num: 4, month: 'April' },
            { num: 5, month: 'May' },
            { num: 6, month: 'June' },
            { num: 7, month: 'July' },
            { num: 8, month: 'August' },
            { num: 9, month: 'September' },
            { num: 10, month: 'October' },
            { num: 11, month: 'November' },
            { num: 12, month: 'December' }
        ];
    }

    static getTimezones(): { value: string, zone: string }[] {
        return [
            { value: '-12', zone: '(GMT-12:00) International Date Line West' },
            { value: '-11', zone: '(GMT-11:00) Midway Island, Samoa' },
            { value: '-10', zone: '(GMT-10:00) Hawaii' },
            { value: '-9', zone: '(GMT-09:00) Alaska' },
            { value: '-8', zone: '(GMT-08:00) Pacific Time (US & Canada)' },
            { value: '-8', zone: '(GMT-08:00) Tijuana, Baja California' },
            { value: '-7', zone: '(GMT-07:00) Arizona' },
            { value: '-7', zone: '(GMT-07:00) Chihuahua, La Paz, Mazatlan' },
            { value: '-7', zone: '(GMT-07:00) Mountain Time (US & Canada)' },
            { value: '-6', zone: '(GMT-06:00) Central America' },
            { value: '-6', zone: '(GMT-06:00) Central Time (US & Canada)' },
            { value: '-6', zone: '(GMT-06:00) Guadalajara, Mexico City, Monterrey' },
            { value: '-6', zone: '(GMT-06:00) Saskatchewan' },
            { value: '-5', zone: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco' },
            { value: '-5', zone: '(GMT-05:00) Eastern Time (US & Canada)' },
            { value: '-5', zone: '(GMT-05:00) Indiana (East)' },
            { value: '-4', zone: '(GMT-04:00) Atlantic Time (Canada)' },
            { value: '-4', zone: '(GMT-04:00) Caracas, La Paz' },
            { value: '-4', zone: '(GMT-04:00) Manaus' },
            { value: '-4', zone: '(GMT-04:00) Santiago' },
            { value: '-3.5', zone: '(GMT-03:30) Newfoundland' },
            { value: '-3', zone: '(GMT-03:00) Brasilia' },
            { value: '-3', zone: '(GMT-03:00) Buenos Aires, Georgetown' },
            { value: '-3', zone: '(GMT-03:00) Greenland' },
            { value: '-3', zone: '(GMT-03:00) Montevideo' },
            { value: '-2', zone: '(GMT-02:00) Mid-Atlantic' },
            { value: '-1', zone: '(GMT-01:00) Cape Verde Is.' },
            { value: '-1', zone: '(GMT-01:00) Azores' },
            { value: '0', zone: '(GMT+00:00) Casablanca, Monrovia, Reykjavik' },
            { value: '0', zone: '(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London' },
            { value: '1', zone: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
            { value: '1', zone: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague' },
            { value: '1', zone: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris' },
            { value: '1', zone: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb' },
            { value: '1', zone: '(GMT+01:00) West Central Africa' },
            { value: '2', zone: '(GMT+02:00) Amman' },
            { value: '2', zone: '(GMT+02:00) Athens, Bucharest, Istanbul' },
            { value: '2', zone: '(GMT+02:00) Beirut' },
            { value: '2', zone: '(GMT+02:00) Cairo' },
            { value: '2', zone: '(GMT+02:00) Harare, Pretoria' },
            { value: '2', zone: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' },
            { value: '2', zone: '(GMT+02:00) Jerusalem' },
            { value: '2', zone: '(GMT+02:00) Minsk' },
            { value: '2', zone: '(GMT+02:00) Windhoek' },
            { value: '3', zone: '(GMT+03:00) Kuwait, Riyadh, Baghdad' },
            { value: '3', zone: '(GMT+03:00) Moscow, St. Petersburg, Volgograd' },
            { value: '3', zone: '(GMT+03:00) Nairobi' },
            { value: '3', zone: '(GMT+03:00) Tbilisi' },
            { value: '3.5', zone: '(GMT+03:30) Tehran' },
            { value: '4', zone: '(GMT+04:00) Abu Dhabi, Muscat' },
            { value: '4', zone: '(GMT+04:00) Baku' },
            { value: '4', zone: '(GMT+04:00) Yerevan' },
            { value: '4.5', zone: '(GMT+04:30) Kabul' },
            { value: '5', zone: '(GMT+05:00) Yekaterinburg' },
            { value: '5', zone: '(GMT+05:00) Islamabad, Karachi, Tashkent' },
            { value: '5.5', zone: '(GMT+05:30) Sri Jayawardenapura' },
            { value: '5.5', zone: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi' },
            { value: '5.75', zone: '(GMT+05:45) Kathmandu' },
            { value: '6', zone: '(GMT+06:00) Almaty, Novosibirsk' },
            { value: '6', zone: '(GMT+06:00) Astana, Dhaka' },
            { value: '6.5', zone: '(GMT+06:30) Yangon (Rangoon)' },
            { value: '7', zone: '(GMT+07:00) Bangkok, Hanoi, Jakarta' },
            { value: '7', zone: '(GMT+07:00) Krasnoyarsk' },
            { value: '8', zone: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi' },
            { value: '8', zone: '(GMT+08:00) Kuala Lumpur, Singapore' },
            { value: '8', zone: '(GMT+08:00) Irkutsk, Ulaan Bataar' },
            { value: '8', zone: '(GMT+08:00) Perth' },
            { value: '8', zone: '(GMT+08:00) Taipei' },
            { value: '9', zone: '(GMT+09:00) Osaka, Sapporo, Tokyo' },
            { value: '9', zone: '(GMT+09:00) Seoul' },
            { value: '9', zone: '(GMT+09:00) Yakutsk' },
            { value: '9.5', zone: '(GMT+09:30) Adelaide' },
            { value: '9.5', zone: '(GMT+09:30) Darwin' },
            { value: '10', zone: '(GMT+10:00) Brisbane' },
            { value: '10', zone: '(GMT+10:00) Canberra, Melbourne, Sydney' },
            { value: '10', zone: '(GMT+10:00) Hobart' },
            { value: '10', zone: '(GMT+10:00) Guam, Port Moresby' },
            { value: '10', zone: '(GMT+10:00) Vladivostok' },
            { value: '11', zone: '(GMT+11:00) Magadan, Solomon Is., New Caledonia' },
            { value: '12', zone: '(GMT+12:00) Auckland, Wellington' },
            { value: '12', zone: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.' },
            { value: '13', zone: '(GMT+13:00) Nuku\'alofa' }
        ];
    }


    // These locale methods were based on https://stackoverflow.com/a/9893752/1919177

    static getLocale(): string {

        let locale = 'en-US';
        if (!!sessionStorage.getItem('locale')) {
            locale = sessionStorage.getItem('locale');
        }

        return locale;
    }

    // The formats shown are from Moment.js here (This is what Sky API uses):  https://momentjs.com/docs/#/displaying/format/
    static getSKYLocaleDateString() {

        const locale = Schedule.getLocale();

        const formats = {
            'bg-BG': 'DD.M.YYYY',
            'da-DK': 'DD-MM-YYYY',
            'de-DE': 'DD.MM.YYYY',
            'en-US': 'M/D/YYYY',
            'fi-FI': 'D.M.YYYY',
            'fr-FR': 'DD/MM/YYYY',
            'he-IL': 'DD/MM/YYYY',
            'hu-HU': 'YYYY. MM. DD.',
            'is-IS': 'D.M.YYYY',
            'it-IT': 'DD/MM/YYYY',
            'nl-NL': 'D-M-YYYY',
            'sv-SE': 'YYYY-MM-DD',
            'et-EE': 'D.MM.YYYY',
            'lv-LV': 'YYYY.MM.DD.',
            'lt-LT': 'YYYY.MM.DD',
            'eu-ES': 'YYYY/MM/DD',
            'de-CH': 'DD.MM.YYYY',
            'en-GB': 'DD/MM/YYYY',
            'fr-BE': 'D/MM/YYYY',
            'it-CH': 'DD.MM.YYYY',
            'nl-BE': 'D/MM/YYYY',
            'nn-NO': 'DD.MM.YYYY',
            'pt-PT': 'DD-MM-YYYY',
            'sv-FI': 'D.M.YYYY',
            'de-AT': 'DD.MM.YYYY',
            'en-AU': 'D/MM/YYYY',
            'es-ES': 'DD/MM/YYYY',
            'fr-CA': 'YYYY-MM-DD',
            'zh-SG': 'D/M/YYYY',
            'de-LU': 'DD.MM.YYYY',
            'en-CA': 'DD/MM/YYYY',
            'fr-CH': 'DD.MM.YYYY',
            'en-NZ': 'D/MM/YYYY',
            'en-IE': 'DD/MM/YYYY',
            'en-ZA': 'YYYY/MM/DD',
            'en-SG': 'D/M/YYYY',
            'es-US': 'M/D/YYYY',
            bg: 'DD.M.YYYY',
            ca: 'DD/MM/YYYY',
            de: 'DD.MM.YYYY',
            el: 'D/M/YYYY',
            en: 'M/D/YYYY',
            fi: 'D.M.YYYY',
            fr: 'DD/MM/YYYY',
            hu: 'YYYY. MM. DD.',
            is: 'D.M.YYYY',
            it: 'DD/MM/YYYY',
            nl: 'D-M-YYYY',
            nb: 'DD.MM.YYYY',
            pl: 'YYYY-MM-DD',
            pt: 'D/M/YYYY',
            ro: 'DD.MM.YYYY',
            ru: 'DD.MM.YYYY',
            hr: 'D.M.YYYY',
            sk: 'D. M. YYYY',
            sv: 'YYYY-MM-DD',
            be: 'DD.MM.YYYY',
            sl: 'D.M.YYYY',
            et: 'D.MM.YYYY',
            lv: 'YYYY.MM.DD.',
            lt: 'YYYY.MM.DD',
            eu: 'YYYY/MM/DD',
            es: 'DD/MM/YYYY'

        };

        return formats[locale] || 'DD/MM/YYYY';

    }

    static getAngularLocaleDateString() {

        const locale = Schedule.getLocale();

        const formats = {
            'bg-BG': 'dd.M.yyyy',
            'da-DK': 'dd-MM-yyyy',
            'de-DE': 'dd.MM.yyyy',
            'en-US': 'M/d/yyyy',
            'fi-FI': 'd.M.yyyy',
            'fr-FR': 'dd/MM/yyyy',
            'he-IL': 'dd/MM/yyyy',
            'hu-HU': 'yyyy. MM. dd.',
            'is-IS': 'd.M.yyyy',
            'it-IT': 'dd/MM/yyyy',
            'nl-NL': 'd-M-yyyy',
            'sv-SE': 'yyyy-MM-dd',
            'et-EE': 'd.MM.yyyy',
            'lv-LV': 'yyyy.MM.dd.',
            'lt-LT': 'yyyy.MM.dd',
            'eu-ES': 'yyyy/MM/dd',
            'de-CH': 'dd.MM.yyyy',
            'en-GB': 'dd/MM/yyyy',
            'fr-BE': 'd/MM/yyyy',
            'it-CH': 'dd.MM.yyyy',
            'nl-BE': 'd/MM/yyyy',
            'nn-NO': 'dd.MM.yyyy',
            'pt-PT': 'dd-MM-yyyy',
            'sv-FI': 'd.M.yyyy',
            'de-AT': 'dd.MM.yyyy',
            'en-AU': 'd/MM/yyyy',
            'es-ES': 'dd/MM/yyyy',
            'fr-CA': 'yyyy-MM-dd',
            'zh-SG': 'd/M/yyyy',
            'de-LU': 'dd.MM.yyyy',
            'en-CA': 'dd/MM/yyyy',
            'fr-CH': 'dd.MM.yyyy',
            'en-NZ': 'd/MM/yyyy',
            'en-IE': 'dd/MM/yyyy',
            'en-ZA': 'yyyy/MM/dd',
            'en-SG': 'd/M/yyyy',
            'es-US': 'M/d/yyyy',
            bg: 'dd.M.yyyy',
            ca: 'dd/MM/yyyy',
            de: 'dd.MM.yyyy',
            el: 'd/M/yyyy',
            en: 'M/d/yyyy',
            fi: 'd.M.yyyy',
            fr: 'dd/MM/yyyy',
            hu: 'yyyy. MM. dd.',
            is: 'd.M.yyyy',
            it: 'dd/MM/yyyy',
            nl: 'd-M-yyyy',
            nb: 'dd.MM.yyyy',
            pl: 'yyyy-MM-dd',
            pt: 'd/M/yyyy',
            ro: 'dd.MM.yyyy',
            ru: 'dd.MM.yyyy',
            hr: 'd.M.yyyy',
            sk: 'd. M. yyyy',
            sv: 'yyyy-MM-dd',
            be: 'dd.MM.yyyy',
            sl: 'd.M.yyyy',
            et: 'd.MM.yyyy',
            lv: 'yyyy.MM.dd.',
            lt: 'yyyy.MM.dd',
            eu: 'yyyy/MM/dd',
            es: 'dd/MM/yyyy'

        };

        return formats[locale] || 'dd/MM/yyyy';

    }


    static getSKYLocaleTimeString() {

        const locale = Schedule.getLocale();

        const formats = {
            'en-US': 'h:mm A',
            'en-GB': 'HH:mm',
            'en-CA': 'h:mm A',
            'en-AU': 'HH:mm',
            'en-IE': 'HH:mm',
            'en-NZ': 'HH:mm',
            'fr-CA': 'HH:mm',

        };

        return formats[locale] || 'HH:mm';

    }

    static getAngularLocaleTimeString() {

        const locale = Schedule.getLocale();

        const formats = {
            'en-US': 'h:mm a',
            'en-GB': 'HH:mm',
            'en-CA': 'h:mm a',
            'en-AU': 'HH:mm',
            'en-IE': 'HH:mm',
            'en-NZ': 'HH:mm',
            'fr-CA': 'HH:mm',

        };

        return formats[locale] || 'HH:mm';

    }


    static getLocaleHourString() {

        const locale = Schedule.getLocale();

        const formats = {
            'en-US': 'hh',
            'en-GB': 'HH',
            'en-CA': 'hh',
            'en-AU': 'HH',
            'en-IE': 'HH',
            'en-NZ': 'HH',
            'fr-CA': 'HH',

        };

        return formats[locale] || 'HH';

    }

}

